@if (isButtonVisible) {
  <!-- Add our custom asterisk if this is in a required field -->
  @if (isInRequiredField) {
    <span class="custom-required-marker">*</span>
  }
  <button
    mat-icon-button
    class="tooltip-button"
    (mousedown)="$event.preventDefault()"
    (click)="openTooltip($event)"
    type="button"
  >
    <mat-icon class="tooltip-icon">help_outline</mat-icon>
  </button>
}
